/* eslint-disable no-undef */
// remove no-js flag
$('html').removeClass('no-js');

$(document).ready(() => {
  initMobileMenu();
  initFancybox();
  initSmallLayoutAnimations();
});

$('.menu .download a.download-link').on('click', function(e){
  //e.preventDefault();
  let title = $(this).attr('title');
  _paq.push(['trackEvent', 'Download', 'Download: ' + title, 'Magazin Download']);
});

// FIX wrong 100vh in iOS and android jumps when the url bar hides
// First we get the viewport height and we multiple it by 1% to get a value for a vh unit
const vh = window.innerHeight * 0.01;
// this is than used as var inside css/less
document.documentElement.style.setProperty('--vh', `${vh}px`);
